import React from 'react';
import styled from 'styled-components';

import Link from 'gatsby-link';

const LozengeWrapper = styled(Link)`
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  background-color: ${
  (props) =>
    props.type === 'product' ? '#E4FCEF' :
    props.type === 'engineering' ? '#DFEBFE' :
    props.type === 'stories' ? '#EAE7FE' :
    props.type === 'company' ? '#FFFAE7' :
    '#F4F5F7'
  };
  color: ${
  (props) =>
    props.type === 'product' ? '#0A6545' :
    props.type === 'engineering' ? '#0E4AA3' :
    props.type === 'stories' ? '#403692' :
    props.type === 'company' ? '#354562' :
    '#F4F5F7'
  };
`;

export const Lozenge = props => {
  return (
    <LozengeWrapper
      to={props.type}
      type={props.type}
    >
      {props.type}
    </LozengeWrapper>
  );
}


// WEBPACK FOOTER //
// ./src/components/Lozenge/index.js